import { render } from "./FourthTierAgent.vue?vue&type=template&id=3b310c9c&scoped=true"
import script from "./FourthTierAgent.vue?vue&type=script&lang=js"
export * from "./FourthTierAgent.vue?vue&type=script&lang=js"

import "./FourthTierAgent.vue?vue&type=style&index=0&id=3b310c9c&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b310c9c"]])

export default __exports__